/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const d = (s) => s.sort((a, t) => a.date.getTime() - t.date.getTime()), o = (s) => {
  let e;
  return s.reduce(
    (t, r) => (e !== r.date.getFullYear() ? (e = r.date.getFullYear(), t.push({ yearFlag: e }, r)) : t.push(r), t),
    []
  );
};
export {
  o as addYearsFlags,
  d as sortEventList
};
